import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";

export default function AuthCallback() {
  const { loginWithGoogle, setUser } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) {
      return;
    }
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    loginWithGoogle(sessionId)
      .then(() => navigate("/", { replace: true }))
      .catch((e) => {
        setUser(false);
        toast.error(apiError(e, "Accesso con Google non riuscito"), { duration: 8000 });
        navigate("/login", { replace: true });
      });
  }, [location.hash, loginWithGoogle, navigate, setUser]);

  return (
    <div data-testid="auth-callback" className="app-shell flex min-h-screen items-center justify-center">
      <Loader2 className="h-6 w-6 animate-spin text-slate-400" />
    </div>
  );
}
